import * as React from "react"
import { cn } from "@/lib/utils/utils"

const ButtonGroup = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    orientation?: "horizontal" | "vertical"
  }
>(({ className, orientation = "horizontal", ...props }, ref) => {
  return (
    <div
      ref={ref}
      data-slot="button-group"
      data-orientation={orientation}
      className={cn(
        "inline-flex items-center rounded-md shadow-xs",
        "[&>button]:rounded-none [&>button]:shadow-none",
        "[&>button:first-child]:rounded-l-md [&>button:last-child]:rounded-r-md",
        "[&>button:not(:first-child)]:border-l-0",
        "[&>button]:focus:z-10 [&>button]:focus-visible:z-10",
        orientation === "vertical" && [
          "flex-col",
          "[&>button:first-child]:rounded-t-md [&>button:first-child]:rounded-l-none",
          "[&>button:last-child]:rounded-b-md [&>button:last-child]:rounded-r-none",
          "[&>button:not(:first-child)]:border-l [&>button:not(:first-child)]:border-t-0",
        ],
        className
      )}
      {...props}
    />
  )
})
ButtonGroup.displayName = "ButtonGroup"

export { ButtonGroup }

